import React, {Component} from 'react';
import {
  Container,
  Row,
  Col,
  Progress
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import DateRange from '../../../shared/components/DateRange';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import { 
  formatStatus, 
  recursivelyLoadAllPages, 
  emojiUrlForRating,
  dayIsInPast ,
  firstNonZeroOrOne,
  alphabeticallySort,
  textContains,
  statusSort,
  daysSinceEpoch
} from '../../../shared/utils';

class ProviderCampaignList extends Component {
  constructor(){
    super();

    this.state = {
      searchText:'',
      isLoading:false,
      currentlyShowing:25
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});
    
    Promise.all([
      recursivelyLoadAllPages(this.props.loadKPIsForAllCampaigns),
      recursivelyLoadAllPages(this.props.loadCampaigns,100),
      recursivelyLoadAllPages(this.props.loadBrands),
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  handleEditClickedWhilePaused(campaignId){
    this.props.revertCampaignToDraft(campaignId)
      .then(() => this.props.history.push(`/superadmin/tutorial/create/${campaignId}`))
  }

  renderButtonsForCampaign(campaign){
    const endDateInPast = campaign.endDate && dayIsInPast(campaign.endDate);

    if(campaign.status === 'draft'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/tutorial/create/${campaign.id}`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Edit
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
              {
                text:'Move to trash', 
                confirmationText:'This is permanent and can not be reverted.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.deleteCampaign(campaign.id)
              }
            ]} 
          />
        </div>
      );
    }

    if(campaign.status === 'pendingAdjoy' || campaign.status === 'pendingAgency'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/review`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Review
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]} 
          />   
        </div>
      );
    }

    if(campaign.status === 'active' || campaign.status === 'ready'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Pause', 
                confirmationText:'Users will not be able to view or complete this experience.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.suspendCampaign(campaign.id)
              },
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]} 
          />          
        </div>
      );
    }

    if(campaign.status === 'suspended' && endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Edit', 
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume', 
                confirmationTitle:'Sorry',
                confirmationText:'End date cannot be in the past. Please update end date before resuming.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => {}
              },
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]} 
          />  
        </div>
      )

    }

    if(campaign.status === 'suspended' && !endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Edit', 
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume', 
                confirmationText:'Users will be now able to complete this experience and earn rewards.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.resumeCampaign(campaign.id)
              },
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]} 
          />  
        </div>
      )

    }

    if(campaign.status === 'outOfFunds' || campaign.status === 'complete'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]} 
          />          
        </div>
      );
    }

    return null;
  }

  renderName(name){
    if(!name || name === 'Untitled campaign' || name === 'Unknown brand'){
      return <i>{name}</i>
    } else {
      return name;
    }
  }

  render(){
    const { campaigns } = this.props;

    const { isLoading } = this.state;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>
              Experiences
            </h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/tutorial/create/new'
            >
              Create Experience
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={isLoading ? [] : campaigns}
              emptyText='Loading experiences...'
              searchPromptText='Search by name or brand'
              defaultSortFunc={(a,b) => firstNonZeroOrOne([
                statusSort(a.status,b.status),
                daysSinceEpoch(a.launchDate) - daysSinceEpoch(b.launchDate),
                alphabeticallySort(a.name,b.name)
              ])}
              columns={[
                {
                  name:'status',
                  width:12,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(formatStatus(a.status), formatStatus(b.status)),
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{formatStatus(item.status)}</span>)
                },
                {
                  display:'experience',
                  name:'name',
                  width:25,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(a.name,b.name), 
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                  ]),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam) || textContains(a.brandName,searchParam),
                  renderCell:(item) => (
                    <div>
                      <h6>
                        <Link to={`/superadmin/experiences/${item.id}/review`}>
                          {this.renderName(item.name)}
                        </Link>
                      </h6>
                      <strong className='BreakWordOnWrap'>
                        {this.renderName(item.brandName)}
                      </strong>
                      <br />
                      <DateRange launchDate={item.launchDate} endDate={item.endDate} />
                      {item.launchDate && ( <br /> )}
                      <span>Experience <strong>#{item.salesNumber}</strong></span>    
                    </div>
                  )
                },
                {
                  display:'completions',
                  name:'numCompletions',
                  width:13,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.numCompletions - a.numCompletions,
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{item.isOrHasBeenLive && item.numCompletions.toLocaleString()}</span>)
                },
                {
                  display:'rating',
                  name:'averageRating',
                  width:13,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.averageRating - a.averageRating,
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      {(item.isOrHasBeenLive && item.numCompletions > 0) && (
                        <span>
                          <img
                            src={emojiUrlForRating(item.averageRating)}
                            className='EmojiRating'
                            alt='rating'
                          />
                          &nbsp;&nbsp;
                          <span>{(item.averageRating + 1).toFixed(2)}</span>
                        </span>
                      )}
                      {(item.isOrHasBeenLive && item.numCompletions === 0) && (
                        <span>N/A</span>
                      )}                      
                    </div>
                  )
                },
                {
                  display:'budget',
                  name:'lifetimeBudget',
                  width:17,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    parseFloat(b.lifetimeBudget || 0) - parseFloat(a.lifetimeBudget || 0),
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      <MoneyDisplay>{item.lifetimeBudget}</MoneyDisplay>
                      {item.isOrHasBeenLive && (
                        <div>
                          <Progress
                            className='BudgetProgressBar'
                            value={(item.budgetSpent / item.lifetimeBudget) * 100}
                            color={(item.lifetimeBudget - item.budgetSpent > 0) ? 'info' : 'danger'}
                          />
                          <small>
                            <MoneyDisplay>{Math.abs(item.lifetimeBudget - item.budgetSpent)}</MoneyDisplay>
                            &nbsp;{(item.lifetimeBudget - item.budgetSpent) >= 0 ? 'remaining' : 'over budget'}
                          </small>
                        </div>
                      )}                      
                    </div>
                  )
                },
                {
                  width:20,
                  renderCell:(item) => this.renderButtonsForCampaign(item)
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ProviderCampaignList;



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignList/components/ProviderCampaignList.js